import React from "react"
import styled from "styled-components"
import { primaryLight } from "../../../constants/colors"
import GImage from "../../../../gatsby/GImage"
import { BadgeType } from "../../../model/FooterType"
import { screenSizes } from "model"

const Wrapper = styled.div`
  max-width: 1200px;
  margin: 40px auto auto;

  @media (max-width: ${screenSizes.tablet}px) {
    padding: 0 10% 10%;
    margin-top: 0;
  }
`

const Header = styled.h4`
  color: ${primaryLight};
`

const BadgesContainer = styled.div`
  display: flex;
  width: 100%;
  max-width: 800px;
  margin-left: -20px;

  @media (max-width: ${screenSizes.tablet}px) {
    flex-direction: column;
    margin-left: 0;
  }

  img {
    filter: grayscale(100%);
  }

  > div {
    flex: 1;
    max-width: 250px;
    margin: 20px;
  }
`

interface Props {
  badges: BadgeType[]
}

const PartnerBadges = ({ badges }: Props): JSX.Element => {
  return (
    <Wrapper>
      <Header>Our Partners</Header>
      <BadgesContainer>
        {badges.map(({ image, url }, i) => (
          <div key={i}>
            {url ? (
              <a href={url} target="_blank">
                <GImage image={image} />
              </a>
            ) : (
              <GImage image={image} />
            )}
          </div>
        ))}
      </BadgesContainer>
    </Wrapper>
  )
}

export default PartnerBadges
